export default {
  GRAMS: 'GRAMS',
  OUNCES: 'OUNCES',
}



// WEBPACK FOOTER //
// ./src/constants/weightUnits.js